import React, { useState, useContext, useEffect } from 'react'
import Avatar from '@material-ui/core/Avatar'
import Button from '@material-ui/core/Button'
import TextField from '@material-ui/core/TextField'
import LockOutlinedIcon from '@material-ui/icons/LockOutlined'
import Typography from '@material-ui/core/Typography'
import { makeStyles } from '@material-ui/styles'
import Container from '@material-ui/core/Container'
import { Link as LinkTo, useHistory } from 'react-router-dom'
import { CgArrowRightO } from 'react-icons/cg'
import Link from '@material-ui/core/Link'

import { useAuth } from 'functions/login'

import AuthContext from 'store/AuthContext'
import { description, version } from '../../../package.json'
import styles from '../pages.module.scss'

const useStyles = makeStyles(theme => ({
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    // width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
}))

const SignIn = () => {
  const classes = useStyles()
  const [username, setUsername] = useState('')
  const [password, setPassword] = useState('')

  const { errors } = useAuth()

  const {
    state: {
      auth,
      accountActions: { doLogin },
    },
  } = useContext(AuthContext)
  // const [errors, setErrors] = useState({})
  const history = useHistory()

  const onSubmit = e => {
    e.preventDefault()
    doLogin(username, password)
  }
  useEffect(() => {
    if (auth) {
      history.push('/designer')
    }
  }, [auth])

  return (
    <Container component="main" maxWidth="xs" className={styles.root}>
      <div className={styles.sign_in_header}>
        <h1 className={styles.signinTitle}>
          {description}
          <span className={styles.sub_heading}>&nbsp; {version}</span>{' '}
        </h1>
        <p className={styles.apiVersion}>Api v0.1.1</p>
      </div>
      <div className={styles.paper}>
        {!auth && (
          <>
            <Avatar className={classes.avatar}>
              <LockOutlinedIcon />
            </Avatar>{' '}
            <Typography component="h1" variant="h5">
              Sign in
            </Typography>
            <form
              className={classes.form}
              noValidate
              onSubmit={e => onSubmit(e)}
            >
              <TextField
                variant="outlined"
                margin="normal"
                required
                fullWidth
                id="username"
                label="Username"
                name="username"
                autoComplete="username"
                autoFocus
                value={username}
                onChange={e => setUsername(e.target.value)}
                error={errors && errors.username && true}
                helperText={
                  errors && errors.username && errors.username.join('\n')
                }
              />
              <TextField
                variant="outlined"
                margin="normal"
                required
                fullWidth
                name="password"
                label="Password"
                type="password"
                id="password"
                autoComplete="current-password"
                value={password}
                onChange={e => setPassword(e.target.value)}
                error={errors && errors.password && true}
                helperText={
                  errors && errors.password && errors.password.join('\n')
                }
              />
              <Typography color="error" variant="caption" align="center">
                {errors && errors.detail}
              </Typography>
              <Button
                fullWidth
                variant="contained"
                color="primary"
                className={classes.submit}
                size="large"
                type="submit"
              >
                Sign In
              </Button>
            </form>
          </>
        )}
        <Link component={LinkTo} className={styles.full_width} to="/Designer">
          <Button fullWidth variant="contained" color="secondary" size="large">
            Designer &nbsp; <CgArrowRightO />
          </Button>
        </Link>
      </div>
    </Container>
  )
}

export default SignIn
